/**
 * Приглашение продолжить в Telegram — вместо оплаты в режиме просмотра.
 *
 * Шторка, а не переход: человек только что выбрал тариф, и закрыв её,
 * он остаётся на том же месте, а не начинает выбор заново.
 */
import { config } from '@/shared/config/env';
import { botStartUrl } from '@/shared/lib/guest';
import { openExternal } from '@/shared/lib/links';
import { Button } from '@/shared/ui/kit/Button';
import { Icon } from '@/shared/ui/kit/Icon';
import { Sheet } from '@/shared/ui/kit/Sheet';

import styles from './Guest.module.css';

interface Props {
  open: boolean;
  /** Что человек хотел сделать — подставляется в текст. */
  action: string;
  onClose: () => void;
}

export function TelegramPrompt({ open, action, onClose }: Props) {
  return (
    <Sheet open={open} title="Продолжите в Telegram" onClose={onClose} fit>
      <div className={styles.prompt}>
        <span className={styles.badge} aria-hidden>
          <Icon name="shield" size={30} />
        </span>
        <p className={styles.text}>
          {action} можно в нашем Telegram-боте — там же подписка, устройства и поддержка. Вход по
          аккаунту Telegram, без регистрации и паролей.
        </p>
        <ul className={styles.perks}>
          <li>
            <Icon name="check" size={16} /> 3 дня бесплатно после запуска бота
          </li>
          <li>
            <Icon name="check" size={16} /> Оплата через СБП, картой или Telegram Stars
          </li>
        </ul>
        <Button block onClick={() => openExternal(botStartUrl)}>
          Открыть @{config.botUsername}
        </Button>
      </div>
    </Sheet>
  );
}
